import { render, staticRenderFns } from "./catalog-item-tech-list.vue?vue&type=template&id=20342574"
import script from "./catalog-item-tech-list.vue?vue&type=script&lang=js"
export * from "./catalog-item-tech-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports